import {
  FORM_FIELD_DEFAULT_MIN_WIDTH,
  MULTILINE_FORM_FIELD_DEFAULT_MIN_WIDTH,
  MULTILINE_FORM_FIELD_DEFAULT_ROWS
} from 'Util/constants'
import { TextField, type TextFieldProps } from '@mui/material'

export type FormTextFieldProps = TextFieldProps & {
  maxLength?: number
}

export default function FormTextField({
  maxLength,
  multiline,
  rows,
  size = 'small',
  sx,
  slotProps,
  ...rest
}: FormTextFieldProps) {
  const defaultMinWidth = multiline
    ? MULTILINE_FORM_FIELD_DEFAULT_MIN_WIDTH
    : FORM_FIELD_DEFAULT_MIN_WIDTH
  const effectiveRows = rows ?? (multiline ? MULTILINE_FORM_FIELD_DEFAULT_ROWS : undefined)

  const mergedSlotProps =
    maxLength === undefined
      ? slotProps
      : {
          ...slotProps,
          htmlInput: { ...slotProps?.htmlInput, maxLength }
        }

  return (
    <TextField
      size={size}
      multiline={multiline}
      rows={effectiveRows}
      slotProps={mergedSlotProps}
      sx={[{ minWidth: defaultMinWidth }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    />
  )
}
